import React from 'react';
import userManager from "../app/UserManager";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SecuredContent from "../common/SecuredContent";
import {Route, Switch, withRouter} from "react-router-dom";
import CobiEditor from "./CobiEditor";
import List from './List';

const propTypes = {
	currentPageTitle: PropTypes.string,

	// The browser history object (provided by react router)
	history: PropTypes.object.isRequired,

	user: PropTypes.object
};

const defaultProps = {
	currentPageTitle: undefined,
};

const mapStateToProps = (state) => {
	return {
		user: state.user,
		currentPageTitle: state.app.currentPageTitle,
	};
};

class AdminRoutes extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.checkUser();
	}

	checkUser() {
		if (!this.props.user || this.props.user.expired) {
			userManager.signinRedirect();
		}
	}

	render() {
		return (
			<React.Fragment>
				<h1>{this.props.currentPageTitle ? this.props.currentPageTitle : '\u00a0'}</h1>
				<div>
					<SecuredContent>
						{() => (
							<Switch>
								<Route path="/admin/landing" render={props => <List {...props} />}/>
								<Route path="/admin/editor" render={props => <CobiEditor {...props} />}/>
								<Route render={() => <div>This page is the default</div>}/>
							</Switch>
						)}
					</SecuredContent>
				</div>
			</React.Fragment>
		);
	}
}

AdminRoutes.propTypes = propTypes;
AdminRoutes.defaultProps = defaultProps;

export default withRouter(connect(mapStateToProps)(AdminRoutes));